import React from "react";
import {useSelector} from "react-redux";

const Reloading = ({force}) => {
    const reloading = useSelector(state => state.main.reloading);

    if (reloading || force) {
        return (
            <div className="loader-holder bg-light-gray loader-opacity">
                <div className="loader">
                    <div className="btn btn-primary btn-loader">
                        <span className="spinner-border spinner-border" role="status" aria-hidden="true"/>
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            </div>
        );
    }
    return null;
}

export default Reloading;